import { apiClient } from '../../../shared/lib/http';
import { clearStoredSession, getStoredSession, setStoredSession } from './tokenStorage';

export async function loginWithCredentials(credentials) {
  const { data } = await apiClient.post('/auth/login', credentials);

  return {
    user: data.user || data.employee || null,
  };
}

export async function loadCurrentUser() {
  const { data } = await apiClient.get('/users/me');
  return data;
}

export async function logoutCurrentSession() {
  await apiClient.post('/auth/logout');
}

export function getSession() {
  return getStoredSession();
}

export function persistSession(session) {
  setStoredSession(session);
}

export function clearSession() {
  clearStoredSession();
}
